export default __webpack_public_path__ + "static/media/720px-Sunset-Title-PMR-light-border.10a8175a.png";